import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["data-state", "data-variant"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("span", {
        "data-state": $props.state,
        "data-variant": $props.variant,
        class: _normalizeClass($setup.cn($setup.badgeVariants({ state: $props.state, variant: $props.variant, size: $props.size }), $setup.props.class)),
        "data-slot": "badge"
    }, [
        _renderSlot(_ctx.$slots, "default")
    ], 10 /* CLASS, PROPS */, _hoisted_1));
}
